import dayjs from 'dayjs';
import { FC, useEffect, useState } from 'react';
import { $class } from '../../../utils';
import Timer from '../../Cabinet/DistributionCenter/Timer';
import './index.scss';

interface IProps {
  startDate?: string;
  expectedDate?: Date;
}

const ProgressBar: FC<IProps> = ({ startDate, expectedDate }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = dayjs(startDate);
    const end = dayjs(expectedDate);
    const startMs = start.valueOf();
    const endMs = end.valueOf();
    const totalTime = endMs - startMs;

    if (totalTime <= 0) {
      setProgress(100);
    } else {
      const currentTime = dayjs().valueOf();
      if (currentTime >= endMs) {
        setProgress(100);
      } else {
        const progress = ((currentTime - startMs) / totalTime) * 100;
        setProgress(progress);
      }
    }
  }, [startDate, expectedDate]);

  return (
    <div className="progress-bar-wrap">
      {expectedDate && <Timer targetDateTimer={dayjs(expectedDate)} expectedDate={expectedDate} />}

      <div
        className={$class(
          'progress-bar',
          ['in-progress', progress !== 100],
          ['completed', progress === 100]
        )}
      >
        <div style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );
};

export default ProgressBar;
